<template>
  <div>
    <el-card style="margin-top: 20px">
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item label="nickname">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.nickname"
            clearable
          />
        </el-form-item>
        <el-form-item label="phone">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.phone"
            clearable
          />
        </el-form-item>
        <el-form-item label="openid">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.openid"
            clearable
          />
        </el-form-item>
        <el-row>
          <el-form-item>
            <el-button
              size="mini"
              style="width: 90px"
              type="primary"
              @click="getList"
              >查询</el-button
            >
            <el-button size="mini" type="primary" @click="clearList"
              >清空查询条件</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column
          prop="nickname"
          label="nickname"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="phone"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="openid"
          label="openid"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="decided(row)"
                >内定</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  props: ["NeiDingData"],
  data() {
    return {
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      list: [],
      id: "",
      searchData: {
        nickname: "",
        phone: "",
        openid: "",
      },
    };
  },
  mounted() {
    this.getList();
    this.id = this.NeiDingData.id;
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    clearList(){
      this.searchData={}
      this.getList()
    },
    getList() {
      this.postAxios("/raffle/list/wxUser", {
        pageEntity: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        wxUser: {
          nickname: this.searchData.nickname,
          phone: this.searchData.phone,
          openid: this.searchData.openid,
        },
      }).then((res) => {
        this.list = res.content;
        this.totalCount = res.totalCount;
      });
    },
    decided(row) {
      this.getAxios("/raffle/option/add/result", {
        optionId: this.id,
        openId: row.openid,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  watch: {
    NeiDingData(newVal, oldVal) {
      this.id = newVal.id;
    },
  },
};
</script>